export const MARK_FIRST_USER_INTERACTION = 'MARK_FIRST_USER_INTERACTION';

export const markFirstUserInteraction = () => dispatch => {
    dispatch({ type: MARK_FIRST_USER_INTERACTION });
};
